export default {
    label_task:{
        en:"Incentive Report",
        bn:'Variety Report'
    },

    label_achievement :{
        en:"Achievement(%)",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_from:{
        en:"Sales From",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_to:{
        en:"Sales To",
        bn:'ব্যবহারকারীরা'
    },

    label_quantity_sales:{
        en:"Quantity (sale)",
        bn:"Quantity"
    },
    label_amount_sales:{
        en:"Amount(sale)",
        bn:"Amount"
    },
    label_unit_price_net:{
        en:"Net Unit Price",
        bn:"Amount"
    },
    label_quantity_target:{
        en:"Quantity (target)",
        bn:"Quantity"
    },
    label_amount_target:{
        en:"Amount (target)",
        bn:"Quantity"
    },
    label_quantity_achievable:{
        en:"Quantity (achievable)",
        bn:"Quantity"
    },
    label_amount_achievable:{
        en:"Amount (achievable)",
        bn:"Amount"
    },
    label_quantity_difference:{
        en:"Quantity (difference)",
        bn:"Quantity"
    },
    label_amount_difference:{
        en:"Amount (difference)",
        bn:"Quantity"
    },
    label_quantity_incentive:{
        en:"Quantity (incentive)",
        bn:"Quantity"
    },
    label_amount_incentive:{
        en:"Amount (incentive)",
        bn:"Quantity"
    },
}